import { useSuspenseQuery } from '@apollo/client/react';
import useLocalStorageState from 'use-local-storage-state';
import { Anzeige } from '@/domain/dienstplan/shared/types/Anzeige';
import {
  AbsatzProduktivitaetEinstellungen,
  AbsatzVorgabe,
  TagebuchEinstellungen,
  UmsatzProduktivitaetEinstellungen,
} from '@/domain/dienstplan/shared/types/tagebuchEinstellungen';
import { GET_CONTROLLING_EINSTELLUNGEN_BY_STANDORT_ID } from '@/domain/dienstplan/shared/hooks/useTagebuchEinstellungen/queries';
import {
  Dienstplan_GetControllingEinstellungenByStandortIdQuery,
  Dienstplan_GetControllingEinstellungenByStandortIdQueryVariables,
} from '@/gql/graphql';

export function useTagebuchEinstellungen(standortId: string): {
  tagebuchEinstellungen?: TagebuchEinstellungen;
  error?: string;
  umsatzplanungAnzeige?: Anzeige;
} {
  const [umsatzplanungAnzeige] = useLocalStorageState<Anzeige>(
    'umsatzplanungAnzeige',
    {
      defaultValue: 'UMSATZ_ABSATZ_PRODUKTIVITAET',
    },
  );

  const { data, error } = useSuspenseQuery<
    Dienstplan_GetControllingEinstellungenByStandortIdQuery,
    Dienstplan_GetControllingEinstellungenByStandortIdQueryVariables
  >(GET_CONTROLLING_EINSTELLUNGEN_BY_STANDORT_ID, {
    variables: { standortId },
    fetchPolicy: 'network-only',
  });

  if (error) {
    return { error: error.message };
  }

  const controllingEinstellungen = data.controlling;

  if (controllingEinstellungen.length > 1) {
    return {
      error:
        'Es sollten nicht für mehrere Standorte die Controllingeinstellungen zurückgegeben werden',
    };
  }

  const tagebuchEinstellungen = data.controlling[0].einstellungen;

  const absatzVorgabe = !tagebuchEinstellungen.absatzProduktivitaet
    .absatzVorgabe
    ? AbsatzVorgabe.Stueck
    : AbsatzVorgabe[tagebuchEinstellungen.absatzProduktivitaet.absatzVorgabe];

  return {
    umsatzplanungAnzeige,
    tagebuchEinstellungen: new TagebuchEinstellungen({
      absatzProduktivitaet: new AbsatzProduktivitaetEinstellungen({
        absatzVorgabe,
        zielProduktivitaet:
          tagebuchEinstellungen.absatzProduktivitaet.zielProduktivitaet,
      }),
      umsatzProduktivitaet: new UmsatzProduktivitaetEinstellungen({
        zielProduktivitaet:
          tagebuchEinstellungen.umsatzProduktivitaet.zielProduktivitaet,
      }),
    }),
  };
}
